import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

export interface SchedulingTaskChangedMessage {
    mailboxInfo: MailboxInfo;
}

export const schedulingTaskChanged: (mailboxInfo: MailboxInfo) => SchedulingTaskChangedMessage =
    action('SCHEDULING_TASK_CHANGED', (mailboxInfo: MailboxInfo) => ({ mailboxInfo }));
